import { render, staticRenderFns } from "./contrastProject.vue?vue&type=template&id=0b6d562d&scoped=true&"
import script from "./contrastProject.vue?vue&type=script&lang=js&"
export * from "./contrastProject.vue?vue&type=script&lang=js&"
import style0 from "./contrastProject.vue?vue&type=style&index=0&id=0b6d562d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d562d",
  null
  
)

export default component.exports